import styled from '@emotion/styled';

// For shared Check Availability components
export const Button = styled.button(
  {
    alignSelf: 'center',
    border: 'none',
    borderRadius: '10px',
    padding: '7px 20px',
    color: 'white',
    cursor: 'pointer',
    letterSpacing: '0.02em',
    width: '90%',
  },
  props => ({ backgroundColor: props.color })
);

export const ButtonsContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

export const ErrorMessage = styled.p`
  color: red;
  margin-top: 10px;
  text-align: center;
`;

export const Overlay = styled.div`
  background: rgba(50, 50, 50, 0.95);
  color: white;
  display: grid;
  height: 100%;
  grid-template-rows: auto 120px;
  padding: 20px 20px 0px 20px;
  position: absolute;
  width: 100%;
  z-index: 10;
`;

export const ScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

export const TitleText = styled.p({
  textAlign: 'center',
  color: 'white',
  fontSize: '16px',
  marginBottom: '20px',
});

export const Wiggle = styled.div`
  animation: shake 1.5s infinite both;

  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0) rotate(-5deg) scale(1.01);
    }

    20%,
    80% {
      transform: translate3d(2px, 0, 0) rotate(10deg) scale() (1.05);
    }

    30%,
    70% {
      transform: translate3d(-4px, 0, 0) rotate(-15deg);
    }

    50% {
      transform: translate3d(-4px, 0, 0) rotate(-15deg) scale(1.15);
    }

    40%,
    60% {
      transform: translate3d(4px, 0, 0) rotate(15deg);
    }
  }
`;
